import React, { useState } from "react";
import { toast } from "react-toastify";
import { Input } from "../../../components/form";
import { Button } from "../../../components/button";
import { useGenerateQrCodes } from "../hooks";

interface IProps {
  onGenerated: (codes: string[]) => void;
}

export const GenerateQrCodesForm: React.FC<IProps> = ({ onGenerated }) => {
  const [count, setCount] = useState("10");
  const { generate, loading } = useGenerateQrCodes();

  const handleSubmit = async () => {
    const n = parseInt(count, 10);
    if (!n || n < 1) {
      toast.error("Indiquer un nombre valide de codes à générer");
      return;
    }
    const results = await generate(n);
    if (results) {
      toast.success(`${results.length} QR codes générés`);
      onGenerated(results.map((r) => r.code));
    }
  };

  return (
    <div className="flex flex-wrap gap-3 items-end">
      <Input
        label="Nombre de codes"
        type="number"
        className="w-full"
        value={count}
        onChange={(e) => setCount(e.target.value)}
      />
      <Button onClick={handleSubmit} loading={loading} disabled={loading}>
        Générer la planche
      </Button>
    </div>
  );
};
